/**
 * @desc IAB safeframe API for some limited functionality
 * {@link http://www.iab.net/media/file/SafeFrames_v1.1_final.pdf}
 */
import type { GeometricInformation, ExternalParty } from '@amzn/safe-frame-client';
import { createNumberCache } from '@/client/apiPage/cache/numberCache.js';
import { createGeomCache } from '@/client/apiPage/cache/geomCache.js';

export interface SafeFrame {
    ext: ExternalParty;
}

export const inViewPercentageCache = createNumberCache();
export const geomCache = createGeomCache();

export const create$sf = (): SafeFrame => {
    return {
        ext: {
            /**
             * @desc Gives the inViewPercentage of the SafeFrame container as a whole number in [0, 100]
             * @returns {Number} returns the inView percentage of the SafeFrame container
             */
            inViewPercentage: (): number => inViewPercentageCache.get(),

            /**
             * @desc Gives the geometric dimension and location of SafeFrame container
             */
            geom: (): GeometricInformation => geomCache.get(),
        },
    };
};
